<mat-sidenav-container fullscreen>



  <mat-sidenav class="sideNav" mode="side" [opened]="showLeftSidenav$| async">

    <ng-container *ngIf="isUserLoggedIn$ | async">
      <app-sidenav-content-user-info [user]="user$ | async">
      </app-sidenav-content-user-info>
    </ng-container>
    <div class="temporary">

      <button *ngIf="!(isUserAuthenticated$ | async)" (click)="login()">Login</button>

      <ng-container *ngIf="isUserLoggedIn$ | async">
        <button (click)="logout()">Logout</button>
        <sidenav-content-user-navigation [user]="user$ | async"></sidenav-content-user-navigation>
      </ng-container>

    </div>

  </mat-sidenav>



  <mat-sidenav-content>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
